import React from 'react';
export function OEMContractsSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 flex flex-col" data-id="element-3018">
      <h2 className="text-2xl font-bold text-[#1967a5] mb-6 border-b border-gray-200 pb-4" data-id="element-3019">
        OEM Maintenance Contracts
      </h2>
      <div className="space-y-4 text-gray-700 text-lg leading-relaxed flex-grow" data-id="element-3020">
        <p data-id="element-3021">
          Every mold shop has qualified repair people who must work on a variety
          of different machine tools and keep them all running so that the shop
          runs smoothly. However, it takes a lot of experience to know the ins
          and outs of your typical WEDM machine. A good preventive maintenance
          (PM) program can keep your WEDM running 24-7.
        </p>
        <blockquote className="border-l-4 border-[#1967a5] pl-4 italic text-gray-600 text-base" data-id="element-3022">
          "Over the years we followed the prescribed maintenance and kept our
          machine in good shape, but we began to have unplanned shutdowns due to
          worn or broken parts. Then our supplier's service department offered
          us an extensive PM program for our machine for just a little more than
          the cost of the parts... Since the PM, we have experienced no loss of
          machining time, the machine cuts at the speed we originally
          experienced and threading reliability has improved immensely."
          <footer className="mt-2 font-bold not-italic" data-id="element-3023">
            - David R. Kennedy III, Kennedy and Bowden Machine Co.
          </footer>
        </blockquote>
      </div>
      <div className="pt-6 mt-auto" data-id="element-3024">
        <a href="https://www.gfms.com/country_US/en/customer-services/uptime.html" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline font-bold text-lg" data-id="element-3025">
          Learn about our UpTime+ Service Contracts →
        </a>
      </div>
    </div>;
}